import { render, staticRenderFns } from "./Biztalk.vue?vue&type=template&id=7fe55572&scoped=true"
import script from "./Biztalk.vue?vue&type=script&lang=js"
export * from "./Biztalk.vue?vue&type=script&lang=js"
import style0 from "./Biztalk.vue?vue&type=style&index=0&id=7fe55572&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fe55572",
  null
  
)

export default component.exports